import { last } from 'lodash-es';
import { heapTrack, IS_NATIVE_APP_CLIENT } from './helpers';
import { prependLocaleToPath } from './localization';

export const fireHeapCustomerLoginEvent = (properties = { isSignInModal: false }) => {
  heapTrack('Web - Sign In', properties);
};

export const fireHeapCustomerCreateEvent = (properties = { hasProvidedPhoneNumber: false, isSignInModal: false }) => {
  heapTrack('Web - Create New Alo Account', properties);
};

export const fireHeapRedeemGWPevent = (properties: {
  productTitle: string;
  variantId: string;
  autoRedeemed: boolean;
}) => {
  const existingGiftsRemovedByUser = localStorage?.getItem('giftsRemovedByUser')?.split(',');
  const wasRemovedFromCartBefore = !!existingGiftsRemovedByUser?.includes(properties.variantId);

  heapTrack('Web - Redeem GWP', { ...properties, wasRemovedFromCartBefore });
};

export const fireHeapRemovalGWPevent = (properties: { productTitle: string; variantId: string }) => {
  heapTrack('Web - Remove GWP', properties);
};

export const fireHeapOpenSignInsignUpModalEvent = (properties: { ctaLocation: string; ctaName: string }) => {
  const pageName = window?.location.pathname === prependLocaleToPath('/') ? 'Home Page' : getPageNameFromURL();
  const environment = IS_NATIVE_APP_CLIENT ? 'Native App' : 'Web';
  heapTrack(`${environment} - Open Sign In/Sign Up Modal`, {
    ...properties,
    pageName,
  });
};

export const fireHeapInteractionWithFAQonLoyaltyPageEvent = (properties: { name: string }) => {
  const environment = IS_NATIVE_APP_CLIENT ? 'Native App' : 'Web';
  heapTrack(`${environment} - Loyalty Page: Interaction with FAQ`, properties);
};

export const fireHeapEarlyLogoutEvent = (properties: {
  lastKnownCustomerId?: string;
  sessionDuration?: number;
  pageUrl: string;
}) => {
  heapTrack('Web - Early Logout Detected', properties);
};

export const fireHeapCustomerLogoutEvent = (properties = { isManualLogout: true }) => {
  heapTrack('Web - Logout', properties);
};

const getPageNameFromURL = () => {
  const pathNameLastPart = last(window.location.pathname.split('/'))
    ?.split('-')
    ?.map((item) => {
      const capitalizedFirstLetter = item.charAt(0).toUpperCase();
      return capitalizedFirstLetter + item.slice(1, item.length);
    })
    .join(' ');
  return `${pathNameLastPart || 'Undefined'} Page`;
};
